import S3Overview from '@/modules/integrations/types/s3/S3Overview'
import S3Settings from '@/modules/integrations/types/s3/S3Settings'

export default Object.freeze({
  type: 's3',
  title: 'Integrations_S3',
  category: 'Integrations_S3_Category',
  description: 'Integrations_S3_Description',
  image: require('@/img/integrations/s3.png'),
  requiresAdmin: false,
  components: {
    overview: S3Overview,
    settings: S3Settings
  },
  urls: {
    guide: 'https://docs.xtremepush.com/docs/third-party-integrations'
  }
})



// WEBPACK FOOTER //
// ./src/modules/integrations/types/s3/index.js